/**
 * !!! IMPORTANT !!!
 *    Istnieje dokładna kopia tego pliku w folderze otp -> otp-loan -> src -> pages -> AffiliatePage.
 *    Dokonując zmian w tym pliku oraz w pliku ./hooks -> useAffiliatePageLogic.tsx należy te same zmiany 
 *    skopiować do projektu otp-loan do bliźniaczych plików. 
 * !!! IMPORTANT !!!
*/

import { ILoanInitLimits } from '../../service/LoanInitService'




/**
 * Enum z nazwami partnerów afiliacyjnych
 */
export enum affiliatePartnersNames {
   Adtraction ="Adtraction", // Dokumentacja Adtraction: https://adtraction.com/server2server.htm?tp=1333495416
   Paytree = "Paytree", // Partner wewnętrzny
   CF = "CF", // Partner Cross Finance
   YouMoney = "YouMoney", // Partner YouMoney
   Loando = "Loando", //Partner Loando
   YouAff = "YouAff", //Partner YouAff
   Finperial = "Finperial", // Partner Finperial
   Autopay = "Autopay", //Partner Autopay
}

export enum affiliateAlternativeOffertsNames {
   SHORT_PERIOD_LOAN = "short_period_loan",
}

/**
 * Obiekt zawierający UNIKALNE nazwy parametrów dla każdego z partnerów afiliacyjnych.
 * Aby mechanizm afiliacji poprawnie rozpoznawał linki od konkrentych partnerów
 * CO NAJMNIEJ JEDEN PARAMETR W KAŻDEJ TABLICY MUSI BYĆ UNIKALNY 
 */
export const affiliatePartnersQueryParams = {
   [affiliatePartnersNames.Adtraction]: [
      "utm_source", "at_gd"
   ],

   [affiliatePartnersNames.Paytree]: [
      "utm_source", "paytree_campaign"
   ],

   [affiliatePartnersNames.CF]: [
      "utm_source", "cf_campaign"
   ],

   [affiliatePartnersNames.YouMoney]: [
      "utm_source", "ym_campaign", "click_id"
   ],

   [affiliatePartnersNames.Loando]: [
      "utm_source", "loando_campaign", "click_id"
   ],

   [affiliatePartnersNames.YouAff]: [
      "utm_source", "ya_campaign", "click_id"
   ],
   [affiliatePartnersNames.Finperial]: [
      "utm_source", "fp_campaign", "click_id"
   ],
   [affiliatePartnersNames.Autopay]: [
      "utm_source", "autopay_campaign", "click_id"
   ],
}

export const affiliateAlternativeOffert = {
   [affiliateAlternativeOffertsNames.SHORT_PERIOD_LOAN]: { // Pożyczka na 12 miesięcy
      name: affiliateAlternativeOffertsNames.SHORT_PERIOD_LOAN,
      defaultLoanAmount: 8000,
      defaultInstalments: 12,
      loanParams: {
         maxInstalments: 12,
         minInstalments: 12,
         minRequestedAmount: 1000,
         maxRequestedAmount: 15000,
         stepRequestedAmount: 500,
      } as ILoanInitLimits
   },
}